<template>
	<div class="cover-wrapper" :style="height">
		<div class="cover" :style="style"></div>
	</div>
</template>

<script>
export default {
	props: {
		item: {
			type: Object,
			default: () => ({}),
		},
		type: {
			type: String,
			default: '',
		},
	},

	computed: {
		typeComp() {
			return this.type.replace('side-by-side--', '')
		},
		height() {
			return {
				'--cover-height': this.getCoverHeightDesktop() + 'px',
				'--cover-height-phone': this.getCoverHeightPhone() + 'px',
			}
		},
		style() {
			let focalPoint = this.item.picture.focalPoint
			return `backgroundImage: url(${this.item.picture.url}); backgroundPosition: ${focalPoint.x *
				100}% ${focalPoint.y * 100}%;`
		},
	},
	methods: {
		getCoverHeightDesktop() {
			switch (this.item.imageHeight) {
				case 'small':
					return 380
				case 'medium':
					return 498
				case 'large':
					return 600
				case 'x-large':
					return 661
				case 'xx-large':
					return 720
				default:
					return 380
			}
		},
		getCoverHeightPhone() {
			switch (this.item.imageHeight) {
				case 'small':
					return 210
				case 'medium':
				case 'large':
				case 'x-large':
					return 250
				case 'xx-large':
					return 400
				default:
					return 210
			}
		},
	},
}
</script>

<style lang="scss">
@import '@/styles/base/_variables.scss';
@import '@/styles/utils/_mixins.scss';

.cover {
	position: absolute;
	top: 0;
	left: 0;
	height: inherit;
	width: inherit;
	background-size: cover;
	background-color: grey;

	&-wrapper {
		background-color: grey;
		position: relative;
		width: 100%;
		height: var(--cover-height);

		@include respond-below('phone') {
			height: var(--cover-height-phone);
		}
	}
}
</style>
